import { useDisclosure } from '@chakra-ui/react/hooks';
import { useCallback } from 'react';

import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';

const useWorkflowInfoHighlight = (
  workflowsInfoShown: boolean,
  currentPage: 'Builds' | 'Artifacts' | 'Test quarantine' | 'Invocations',
  hasAnyBuild?: boolean,
) => {
  const { mutate } = useMutateUserMetadata();
  const { onClose: onHelpClose, open } = useDisclosure({
    defaultOpen: !workflowsInfoShown && !hasAnyBuild && currentPage === 'Builds',
  });

  const onWorkflowInfoClose = useCallback(() => {
    onHelpClose();
    mutate({ app_details_workflow_product_info_shown: true });
  }, [mutate, onHelpClose]);

  return {
    onWorkflowInfoClose,
    isWorkflowInfoVisible: open,
  };
};

export default useWorkflowInfoHighlight;
